import { render, staticRenderFns } from "./zhuanjia-project-list.vue?vue&type=template&id=1b4b32de&scoped=true"
import script from "./zhuanjia-project-list.vue?vue&type=script&lang=js"
export * from "./zhuanjia-project-list.vue?vue&type=script&lang=js"
import style0 from "./zhuanjia-project-list.vue?vue&type=style&index=0&id=1b4b32de&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4b32de",
  null
  
)

export default component.exports